import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ContentStory, ContentSubStory, PromotionSubStory, SubStoryType } from '../story-content.model';
import { StoryContentService } from '../story-content.service';
import { StoryPromotionComponent } from '../story-promotion.component';
import { StoryContentVideoComponent } from './story-content-video.component';

@Component({
    selector: 'ms-sub-story-body',
    templateUrl: './sub-story-body.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [StoryContentVideoComponent, StoryPromotionComponent, NgOptimizedImage],
})
export class SubStoryBodyComponent {
    subStory = input.required<ContentSubStory>();
    story = input.required<ContentStory>();

    promotion = computed(() => {
        return this.subStory().type === SubStoryType.Promotion ? (this.subStory() as PromotionSubStory).promotion : undefined;
    });

    constructor(private storyContentService: StoryContentService) {}

    setProgressBarStatus(value: boolean): void {
        if (value) {
            this.storyContentService.pause();
        } else {
            this.storyContentService.play();
        }
    }
}
